import client from './client';

export async function login(adminAccount, adminPassword) {
  const res = await client.post('/login', { adminAccount, adminPassword });
  return res.data; // ApiResponse<AdminLoginResponseVO>
}
